export default __webpack_public_path__ + "static/ogX-906e74a1f5dc1bee185cf9752ce33cad.jpg";